import graphql from "../../graphql";

export default {
  namespaced: true,
  state: {
    buttonsDisabled: false,
    pointerEvent: "initial",
    orderCompletedAt: null,
  },
  getters: {
    buttonsDisabled: state => state.buttonsDisabled,
    pointerEvent: state => state.pointerEvent,
    orderCompletedAt: state => state.orderCompletedAt,
  },
  actions: {
    setButtonsDisabled: (context, disabled) => context.commit("setButtonsState", disabled),
    setPointerEvent: (context, eventName) => context.commit("setPointerEvent", eventName),
    fetchOrderCompletedAt: (context, orderId) => {
      graphql
        .query({ query: orderCompletedAtQuery(), variables: { id: orderId } }, { cache: false })
        .then(response => {
          context.commit("setOrderCompletedAt", response.data.currentOrder.completedAt);
        });
    },
  },
  mutations: {
    setButtonsState: (state, disabled) => {
      state.buttonsDisabled = disabled;
    },
    setPointerEvent: (state, eventName) => {
      state.pointerEvent = eventName;
    },
    setOrderCompletedAt(state, orderCompletedAt) {
      state.orderCompletedAt = orderCompletedAt;
    },
  },
};

const orderCompletedAtQuery = () => `
  query Order($id: ID!){
    currentOrder(id: $id) {
      completedAt
    }
  }
`;
